import { render, staticRenderFns } from "./createExam.vue?vue&type=template&id=80f69882&scoped=true&"
import script from "./createExam.vue?vue&type=script&lang=js&"
export * from "./createExam.vue?vue&type=script&lang=js&"
import style0 from "./createExam.vue?vue&type=style&index=0&id=80f69882&lang=scss&scoped=true&"
import style1 from "./createExam.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./createExam.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f69882",
  null
  
)

export default component.exports